import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

import { useMockUseFlags } from './mock-flags';

export const useFlags =
  (process.env.NODE_ENV === 'development' || 'IS_STORYBOOK' in window) && !('Cypress' in window)
    ? useMockUseFlags
    : useLDFlags;

export function useFlag<T>(flag: string): T {
  return useFlags()?.[flag] as T;
}
